/*
 * Author: Dw
 * File Created: Wednesday, 24-08-07 04:08 pm
 * Last Modified: Thursday, 25-06-19 11:23 am, by Dw
 */

import type { LanguageType } from './hooks/useLanguage';

export const locales = ['en', 'zh'];

export const SGD_CURRENCY_UNIT = 'SGD';
export const USD_CURRENCY_UNIT = 'USD';

export const basePath = process.env.NEXT_PUBLIC_PREFIX_PATH || '';

export const externalLink: Record<
  'referralReward' | 'faq',
  Record<LanguageType, string>
> = {
  referralReward: {
    zh: 'https://help.thedecard.com/jiang-li-ji-hua/yao-qing-you-li',
    en: 'https://help.thedecard.com/en/reward/referral',
  },
  faq: {
    zh: 'https://help.thedecard.com/jiang-li-ji-hua/xiao-fei-fan-xian',
    en: 'https://help.thedecard.com/en/reward/cashback',
  },
};

export const DECARD_VISA_CATEGORY_ID = '30102000';

export const GEETEST_CAPTCHA_ID_MAP = {
  REGISTER: '8331016addc31fbc00b2fc5f7dfbae89',
  FORGET_PASSWORD: '660c8a3413cf80a961686c605f670566',
};
